import { Stack, Typography } from '@mui/material'
import Image from 'next/image'

import Button from '@/components/base/Button'
import useNemoWallet from '@/hooks/use-nemo-wallet'
import useTrans from '@/hooks/useTrans'

const ConnectWalletToContinue = () => {
  const trans = useTrans()
  const { connectWallet } = useNemoWallet()

  return (
    <Stack
      data-testid="connect-wallet-to-continue"
      className="items-center justify-start my-4 h-screen">
      <Stack className="items-center justify-center h-3/6 gap-10">
        <Image src="/connect_wallet.svg" alt="thanh-toan" width={161} height={0} className="w-[120px] h-auto sm:w-[161px]" />
        <Stack className="items-center justify-center gap-8">
          <Typography className="font-bold text-lg sm:text-2xl">
            {trans.common.connect_your_wallet_to_continue}
          </Typography>
          <Button onClick={connectWallet} className="w-[220px]" size="xl">
            {trans.common.connect_wallet}
          </Button>
        </Stack>
      </Stack>
    </Stack>
  )
}

export default ConnectWalletToContinue
